import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/glgift',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-glgift" */ '~/pages/GlGift/pages/glgift-act/Container'
        )
    ),
  },
  {
    path: '/glgift/commodal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-glgift-commodal" */ '~/pages/GlGift/pages/glgift-commodal'
        )
    ),
  },
] as RouteConfig[]
